import '@shopify/polaris/build/esm/styles.css';
import { goBackendApi, phpBackendApi } from 'hooks/api/httpApi';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router/dom';
import { IntercomProvider } from 'react-use-intercom';
import { store } from 'redux/store';
import router from 'routes';
import './App.css';

const INTERCOM_APP_ID = import.meta.env.VITE_APP_INTERCOM_APP_ID;

// Dev-only: call the backend from the browser console, e.g. `await goApi.get('/api/v1/settings')`
if (import.meta.env.DEV) {
    Object.assign(window, { goApi: goBackendApi(), phpApi: phpBackendApi() });
}

createRoot(document.getElementById('root')!).render(
    <>
        <IntercomProvider appId={INTERCOM_APP_ID}>
            <Provider store={store}>
                <RouterProvider router={router} />
            </Provider>
        </IntercomProvider>
    </>
);
